import { CallApi } from "./common";
import { UploadResponse, UploadStartRequest, startUpload, uploadToS3 } from "./upload";

export interface AssetUploadResponse extends UploadResponse {
  id: string;
  mediumImageUrl: string;
  smallImageUrl: string;
}

export interface AssetUploadStartRequest extends UploadStartRequest {
  id?: string;
  type: string;
}

const callAPI = CallApi("assets");

export const replace = async (
  id: string,
  type: string,
  file: File,
  signal?: AbortSignal
): Promise<AssetUploadResponse> => {
  const form: AssetUploadStartRequest = {
    type,
    id,
    filename: file.name,
    contentType: file.type,
  };

  const { formData, ...data } = await startUpload<
    AssetUploadStartRequest,
    AssetUploadResponse
  >(form, callAPI, '/upload', signal);
  return {
    ...data,
    upload: uploadToS3(file, formData),
  };
};